<template>
  <div id="requests">
    <b-alert variant="info" :show="!$store.state.user">
      <b-row>
        <b-col cols="auto" class="my-auto">
          <NetvsIcon icon="info" size="3x" />
        </b-col>
        <b-col class="h-100 my-auto">
          <p class="my-auto">
            {{ $t('views.requests.info') }}
            <router-link to="/login" class="ml-2"><b-button variant="outline-primary">{{ $t('system.login') }}</b-button></router-link>
          </p>
        </b-col>
      </b-row>
    </b-alert>
    <!--Nested grid to render each column individually --->
    <b-row>
      <b-col sm>
        <div v-for="(option, index) in visible_options" :key="option.key">
          <RequestCard :option="option" v-if="index % 2 === 0"></RequestCard>
        </div>
      </b-col>

      <b-col sm>
        <div v-for="(option, index) in visible_options" :key="option.key">
          <RequestCard :option="option" v-if="index % 2 === 1"></RequestCard>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PatchRequestForm from '@/components/PatchRequestForm'
import BCDRequestForm from '@/components/requests/BCDRequestForm.vue'
import apiutil from '@/util/apiutil'
import NetvsIcon from '@/icons/NETVSIcon.vue'
import RequestCard from '@/components/requests/RequestCard.vue'
import VPNBCDRequestForm from '@/components/requests/VPNBCDRequestForm.vue'
import WLANBCDRequestForm from '@/components/requests/WLANBCDRequestForm.vue'
import bwCloudOSRequestForm from '@/components/requests/bwCloudOSRequestForm.vue'
import VMwareVMRequestform from '@/components/requests/vmware/VMwareVMRequestform.vue'

export default {
  name: 'RequestOverview',
  components: { RequestCard, NetvsIcon},
  data() {
    const self = this
    return {
      options: [
        {
          modal: PatchRequestForm,
          modal_id: 'patch-request-form',
          key: 'patch_request',
          badge_content: this.$store.getters.patch_request_actions_count,
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('patchrequest') && (apiutil.checkPermission(self.$store.state, 'nd.ro:module') || self.$store.state.is_ou_admin)
          },
          disabled_text() {
            if (!self.$store.state.sysinfo.js_mods.includes('patchrequest')) {
              return null
            }
            if (!apiutil.checkPermission(self.$store.state, 'nd.ro:module') && !self.$store.state.is_ou_admin) {
              return 'views.requests.patch_request.no_permission'
            }
            return null
          }
        },
        {
          modal: BCDRequestForm,
          modal_id: 'bcd-request-form',
          key: 'bcd_request',
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('bcdrequest') && self.$store.state.is_ou_admin
          },
          disabled_text() {
            if (!self.$store.state.sysinfo.js_mods.includes('bcdrequest')) {
              return null
            }
            if (!self.$store.state.is_ou_admin) {
              return 'views.requests.bcd_request.no_permission'
            }
            return null
          }
        },
        {
          modal: VPNBCDRequestForm,
          modal_id: 'vpn-bcd-request-form',
          key: 'vpn-bcd-request',
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('bcdrequest') && self.$store.state.is_ou_admin
          },
          disabled_text() {
            if (!self.$store.state.sysinfo.js_mods.includes('bcdrequest')) {
              return null
            }
            if (!self.$store.state.is_ou_admin) {
              return 'views.requests.vpn-bcd-request.no_permission'
            }
            return null
          }
        },
        {
          modal: WLANBCDRequestForm,
          modal_id: 'wlan-bcd-request-form',
          key: 'wlan-bcd-request',
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('bcdrequest') && self.$store.state.is_ou_admin
          },
          disabled_text() {
            if (!self.$store.state.sysinfo.js_mods.includes('bcdrequest')) {
              return null
            }
            if (!self.$store.state.is_ou_admin) {
              return 'views.requests.wlan-bcd-request.no_permission'
            }
            return null
          }
        },
        {
          modal: bwCloudOSRequestForm,
          modal_id: 'bw-cloud-os-request-form',
          key: 'bw_cloud_os_custum_quota',
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('bwcloud_os_quota')
          },
          disabled_text() {
            if (!self.$store.state.user) {
              return 'views.requests.bw_cloud_os_custum_quota.no_permission'
            }
            return null
          }
        },
        {
          modal: VMwareVMRequestform,
          modal_id: 'vmware-vm-request-form',
          key: 'vmware-vms',
          visible() {
            return self.$store.state.sysinfo.js_mods.includes('vmware_vm_request')
          },
          disabled_text() {
            if (!self.$store.state.user) {
              return 'views.requests.vmware-vms.no_permission'
            }
            return null
          }
        },
        {
          address: this.$store.state.sysinfo.netdb_admin_base + '/~netadmin/patch_request/',
          key: 'patch_request_cs',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('patchrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-patch-request-cn',
          key: 'patch_request_cn',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('patchrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-iot-request',
          key: 'kit_iot_ticket',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('bcdrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-bcd-request',
          key: 'new_bcd_net',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('bcdrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-vpn2vlan',
          key: 'vpn2vlan_access',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('bcdrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-wifi2vlan',
          key: 'wifi2vlan_access',
          visible() {
            return !self.$store.state.sysinfo.js_mods.includes('bcdrequest')
          }
        },
        {
          address: 'https://www.scc.kit.edu/ts-dhcp-for-bcd',
          key: 'dhcp_for_bcd'
        },
        {
          address: 'https://www.scc.kit.edu/ts-fw-rule',
          key: 'new_fw_rule'
        },
        {
          address: 'https://www.scc.kit.edu/ts-rap-for-home',
          key: 'rap_for_home'
        }
      ]
    }
  },
  watch: {
    '$store.getters.patch_request_actions_count': function (newVal, oldVal) {
      this.options[0].badge_content = newVal // TODO: Find by key
      // This is ugly and disgusting, but it works
      // badge_content really didn't want to update otherwise
    }
  },
  computed: {
    visible_options() {
      return this.options.filter(option => {
        console.log(option.disabled_text)
        if (option.visible) {
          return option.visible() || (option.disabled_text && option.disabled_text())
        } else {
          return true
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
